import React from "react";

import "./index.css";

import AdditionalLocationContainer from "./AdditionalLocationContainer";
import { AdditionalLocationContextProvider } from "../../../../contexts/additional-location.context";

function AdditionalLocation(props) {
  return (
    <div className="table-container">
      <AdditionalLocationContainer />
    </div>
  );
}

export default AdditionalLocation;
